// Icona divisione ordine: nuovo SVG fornito
export default function SplitIcon(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 301.07 299.29"
			width="1em"
			height="1em"
			fill="currentColor"
			aria-hidden="true"
			{...props}
		>
			<path d="M300.19,142.66l-50.25-48.81-65.99,65.75-66.71-65.75-66.85,65.7L1.82,110.29l-1-3.98c2.44-24.68-3.25-55.48.51-79.42C3.5,13.03,15.46,3.06,28.76.45L270.75,0c12.43-.41,29.44,16.64,29.44,28.42v114.23Z" />
			<path d="M.88,156.63l50.25,48.81,66.78-64.67,65.91,64.67,66.85-64.7,48.58,48.26,1,3.98c-2.44,24.68,3.25,55.48-.51,79.42-2.18,13.85-14.14,23.83-27.44,26.44l-241.99.44c-12.43.41-29.44-16.64-29.44-28.42v-114.23Z" />
		</svg>
	);
}
